module.exports = __webpack_public_path__ + "static/media/editIcon.ca18d1fb.svg";